var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "issue-list" }, [
    _c("div", { staticClass: "issue-list__tabs-header" }, [
      _c(
        "div",
        { staticClass: "issue-list__tabs", attrs: { role: "tablist" } },
        [
          _c(
            "button",
            {
              staticClass: "issue-list__tab",
              class: { "issue-list__tab--active": _setup.isGrouped },
              attrs: {
                type: "button",
                role: "tab",
                "aria-selected": _setup.isGrouped,
              },
              on: {
                click: function ($event) {
                  _setup.isGrouped = true
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _setup.t("proofreadingReviseManuscriptPage.groupView")
                  ) +
                  " "
              ),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "issue-list__tab",
              class: { "issue-list__tab--active": !_setup.isGrouped },
              attrs: {
                type: "button",
                role: "tab",
                "aria-selected": !_setup.isGrouped,
              },
              on: {
                click: function ($event) {
                  _setup.isGrouped = false
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _setup.t(
                      "proofreadingReviseManuscriptPage.manuscriptOrderView"
                    )
                  ) +
                  " "
              ),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "issue-list__tabs-track",
          attrs: { "aria-hidden": "true" },
        },
        [
          _c(
            "div",
            {
              staticClass: "issue-list__tabs-indicator",
              style: {
                transform: _setup.isGrouped
                  ? "translateX(0)"
                  : "translateX(100%)",
              },
            },
            [_c("div", { staticClass: "issue-list__tabs-indicator__inner" })]
          ),
        ]
      ),
    ]),
    _c(
      "div",
      { ref: "issueListRef", staticClass: "issue-list__body" },
      [
        !_setup.hasIssues
          ? _c("p", { staticClass: "issue-list__empty" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _setup.t("proofreadingReviseManuscriptPage.noIssues")
                  ) +
                  " "
              ),
            ])
          : _setup.isGrouped
          ? _vm._l(_vm.issueCategories, function (category, index) {
              return _c(_setup.IssueListGroup, {
                key: category.id,
                attrs: {
                  "category-id": category.id,
                  label: category.label,
                  issues: category.issues,
                  "active-issue-ids": _setup.activeIssueIds,
                  "default-open": index === 0,
                  index: index,
                },
                on: {
                  "issue-click": _setup.onIssueClick,
                  "issue-apply": _setup.onIssueApply,
                  "issue-revert": _setup.onIssueRevert,
                  "issue-reject-toggle": _setup.onIssueRejectToggle,
                  "issue-hover": _setup.onIssueHover,
                },
              })
            })
          : _c(
              "ul",
              { staticClass: "issue-list__flat-list" },
              _vm._l(_setup.flatIssues, function (entry, index) {
                return _c(_setup.IssueItem, {
                  key: entry.issue.id,
                  attrs: {
                    issue: entry.issue,
                    "is-active": _setup.isIssueActive(entry.issue),
                    "active-location-ids": _setup.activeIssueIds,
                    "category-label": entry.issue.issueTypeLabel,
                    "default-open": index === 1,
                  },
                  on: {
                    click: _setup.onIssueClick,
                    apply: (issue) =>
                      _setup.onIssueApply({
                        categoryId: entry.categoryId,
                        issue,
                      }),
                    revert: (issue) =>
                      _setup.onIssueRevert({
                        categoryId: entry.categoryId,
                        issue,
                      }),
                    "reject-toggle": (issue) =>
                      _setup.onIssueRejectToggle({
                        categoryId: entry.categoryId,
                        issue,
                      }),
                    hover: _setup.onIssueHover,
                  },
                })
              }),
              1
            ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }